export default __webpack_public_path__ + "static/media/createaccountimg.8ef78a29.svg";